import Vue from 'vue'
import Router from 'vue-router'

const CheckList = () => import('../pages/CheckList/index.vue')
const ShouldList = () => import('../pages/ShouldList/index.vue')
const ActualList = () => import('../pages/ActualList/index.vue')
const ActualDetail = () => import('../pages/ActualList/components/ActualDetail.vue')
// const ActualDetail = () => import('../pages/ActualList/index.vue')
// const ApplyDetails = () => import('../pages/ApplyDetails/index.vue')
const ShouldListDetail = () => import('../pages/ShouldList/components/ShouldListDetail.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'CheckList',
      component: CheckList
    }, {
      path: '/ShouldList',
      name: 'ShouldList',
      component: ShouldList
    }, {
      path: '/ActualList',
      name: 'ActualList',
      component: ActualList
    }, {
      path: '/CheckList',
      name: 'CheckList',
      component: CheckList
    }, {
      path: '/ShouldListDetail',
      name: 'ShouldListDetail',
      component: ShouldListDetail
    }, {
      path: '/ActualDetail',
      name: 'ActualDetail',
      component: ActualDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js